module.exports = __webpack_public_path__ + "static/img/DSC_0197.e346d5b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DSC_0197.jpeg
// module id = 166
// module chunks = 2